import OrdersRtdb from './services/orders-rtdb';

const FirebaseRtDb = {
  install(app, { store }) {
    const ordersRtdb = new OrdersRtdb(store);

    /** Usage: inside of vue components: this.$realTimeOrdersDatabase */
    app.config.globalProperties.$realTimeOrdersDatabase = ordersRtdb;
  }
};

export default FirebaseRtDb;

